/* eslint-disable no-console */
import axios, { AxiosError } from "axios";
import { axiosRequestConfig, ProfileUrl } from "../apiConstants";

export interface ISavePhoneNumberRequest {
  countryCode: string;
  areaCode: string;
  phone: string;
  phoneExtension: string;
}

const postPhoneNumber = async (
  jwt: string,
  personId: number,
  phoneType: string,
  data: ISavePhoneNumberRequest
) => {
  try {
    return await axios.post(
      `${ProfileUrl}/${phoneType}Phone/${personId}`,
      data,
      axiosRequestConfig(jwt)
    );
  } catch (error) {
    console.error("error: ", error);
    return (error as AxiosError).response;
  }
};

export default postPhoneNumber;
